import queryString from "query-string";

function getQueryString(): string {
  if (typeof window !== "undefined") {
    return window.location.search;
  }
  return "";
}

export function getQueryStringValue(key, query: string = getQueryString()) {
  if (typeof window != "undefined") {
    return queryString.parse(query)[key] || "";
  }

  return undefined;
}
